import { DocumentDto, DocumentUrlDto } from '@app/data/dtos/ptrab/documents/document.dto';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { DocumentUrl } from '@app/entities/models/ptrab/documents/document-url.model';
import { Document } from '@app/entities/models/ptrab/documents/document.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapDocument: MapFromFn<DocumentDto, Document> = (value) =>
  Builder.forModel(Document)
    .id(value.document_id)
    .date(value.date)
    .status(value.status)
    .subclass(value.subclass)
    .build();

export const mapDocumentsData: MapFromFn<IDataResponse<DocumentDto[]>, Document[]> = (value) =>
  value.data.map(mapDocument);

export const mapDocumentsDataOnBoarding: MapFromFn<IDataResponse<DocumentDto[]>, Document[] | []> = (value) =>
  value?.data?.length ? value.data.map(mapDocument) : [];

export const mapDocumentData: MapFromFn<IDataResponse<DocumentDto | null>, Document | null> = (value) =>
  value?.data ? mapDocument(value.data) : null;

export const mapUrlDocument: MapFromFn<DocumentUrlDto, DocumentUrl> = (value: DocumentUrlDto): DocumentUrl =>
  Builder.forModel(DocumentUrl).url(value.url).status(value.status).build();
